/** Stored `nodeType.name` for the technician/user node type — the `Sibling`
 *  system-category structure type. The UI displays it as "User" everywhere via
 *  {@link displayNodeTypeName}, but the stored/filter value stays "Sibling". */
export const SIBLING_NODE_TYPE_NAME = 'Sibling';

/** Map a stored node-type name to its user-facing label. Only `Sibling` is
 *  aliased (to "User"); every other name is shown as-is. */
export const displayNodeTypeName = (name?: string | null): string => {
  if (!name) return '';
  return name === SIBLING_NODE_TYPE_NAME ? 'User' : name;
};
